<template>
  <div class="page-list-type">
    <Notification
      v-if="notification.active"
      :content="notification.content"
      :type="notification.type"
    />

    <PageHeader>
      <div class="heading">
        <h1>
          <router-link :to="{name: 'list-types'}">List Types</router-link> /
          <strong class="name">{{ listType.name }}</strong>
        </h1>

        <Btn primary hasIcon tooltip="Edit List">
          <router-link
            :to="{name: 'edit-list-type', params: {listTypeId: listTypeId}}"
          >
            <Sprite name="edit" />
          </router-link>
        </Btn>
      </div>

      <div class="header-actions">
        <Btn secondary hasIcon @click="activateConfirm" tooltip="Delete list type">
          <Sprite name="bin" />
        </Btn>
      </div>
    </PageHeader>

    <div class="page-columns">
      <div class="col main">
        <div class="page-content">
          <ul>
            <li>
              <p>Name: {{ listType.name }}</p>
            </li>
          </ul>
        </div>
      </div>

      <div class="col side">
        <PageSummary>
          <div>
            <h1>List Type</h1>
            <p>This is the individual list type.</p>
          </div>
        </PageSummary>
      </div>
    </div>

    <router-view />

    <Confirm
      v-if="confirmActive"
      @confirm="deleteListType"
      @cancel="cancel"
      :message="deleteMessage"
      :link="{name: 'ListTypes'}"
    />
  </div>
</template>

<script>
import page from '@/mixins/page'
import pagination from '@/mixins/pagination'
import confirm from '@/mixins/confirm'
import notification from '@/mixins/notification'

import {
  readListTypeData,
  updateListTypeData,
  deleteListTypeData
} from '@/lib/list_types'

import PageHeader from '@/components/PageHeader'
import PageSummary from '@/components/PageSummary'
import Confirm from '@/components/Confirm'
import Sprite from '@/components/Sprite'
import Btn from '@/components/Btn'

export default {
  name: 'ListType',

  mixins: [page, pagination, confirm, notification],

  props: {
    listTypeId: {
      type: String,
      required: true
    }
  },

  components: {
    PageHeader,
    PageSummary,
    Sprite,
    Confirm,
    Btn
  },

  data() {
    return {
      listType: {}
    }
  },

  methods: {
    getData() {
      readListTypeData(this.listTypeId).then(({data}) => {
        this.listType = data
      })
    },

    submitListType() {
      updateListTypeData(this.listTypeId, this.listType).then(({data}) => {
        this.listType = data
      })
    },

    deleteListType() {
      deleteListTypeData(this.listTypeId).then(() => {
        this.confirmActive = false
        this.triggerNotification('success', 'list type', 'deleted')

        window.setTimeout(() => {
          this.$router.push({
            name: 'list-types'
          })
        }, this.closeDelay)
      })
    }
  },

  computed: {
    title() {
      return this.listType.name
    },

    deleteMessage() {
      return 'Are you sure you want to delete this list type? It will break sites that are currently using it!'
    }
  },

  mounted() {
    this.getData()
  },

  watch: {
    $route() {
      this.getData()
    }
  }
}
</script>

<style lang="sass">
@import '../stylesheets/base/variables'
@import '../stylesheets/helpers/mixins'
@import '../stylesheets/helpers/extends'

.page-list-type
  @extend %page
</style>
